
<div mat-dialog-title>Unrecognized Securities in Your File<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <mat-card class="warn block">
    <mat-card-title class="warn">{{data.unrecognized.Models?.length}} model contains {{data.unrecognized.Securities?.length}} unrecognized securities.
    </mat-card-title>
  </mat-card>
  <div>
    <table width="100%">
      <tr>
        <td style="vertical-align: top; width: 72px; padding: 10px 0;"><strong>Models with unrecognized securities:</strong></td>
        <td style="padding: 10px;">
          <div style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
            @if (data.unrecognized.Models && data.unrecognized.Models.length > 0) {
              <table  style="width:100%;">
                @for (account of data.unrecognized.Models; track account; let i = $index) {
                  <tr>
                    <td style="max-width: 410px; white-space:nowrap; text-overflow: ellipsis;">{{data.unrecognized?.Models[i]}}</td>
                  </tr>
                }
              </table>
            }
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class= "left"> (These securities are not available in Schwab's security master.)</div>
  <div>
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'240px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      [rowData] = 'data.unrecognized.Securities'
    (gridReady) = "onGridReady($event)"></irb-inventory-grid>
  </div>
  <div>Models with unrecognized securities won't be imported.</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
  <button id="continueButton" (click)="completeUnrecognized()" class="btn-medium-primary">Continue</button>
</mat-dialog-actions>
